import type { HTMLAttributes, ReactNode } from 'react';
import { pickCss } from '@/shared/lib/css-utils';
import css from './alert.module.scss';

const alertCss = pickCss(css, css.root);

type AlertVariant = 'error' | 'info' | 'success' | 'warning';

type AlertProps = HTMLAttributes<HTMLDivElement> & {
  variant?: AlertVariant;
  icon?: ReactNode;
};

export const Alert = ({
  variant = 'error',
  icon,
  className,
  children,
  ...restProps
}: AlertProps) => (
  <div className={alertCss({ variant }, className)} {...restProps}>
    {icon && <span className={css.icon}>{icon}</span>}
    <span>{children}</span>
  </div>
);
